import { render, staticRenderFns } from "./spotGoods.vue?vue&type=template&id=6870be5a&scoped=true"
import script from "./spotGoods.vue?vue&type=script&lang=js"
export * from "./spotGoods.vue?vue&type=script&lang=js"
import style0 from "./spotGoods.vue?vue&type=style&index=0&id=6870be5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870be5a",
  null
  
)

export default component.exports